import { EDebugWinPresentationEvents } from '@Core/Win/States/WinPresentationStates';
import EventsCenter from '@Managers/Events/EventsCenter';
import { getBetState, getDebugWinPresentationModeState } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';
import cn from 'classnames';
import React, { useEffect, useReducer, useState } from 'react';
import styles from './WinMessages.scss';

interface IComponentState {
    customWin: number | '';
}

const WinMessagesCustom: React.FC = () => {
    const [state, setState] = useReducer((s: IComponentState, ns: Partial<IComponentState>) => ({ ...s, ...ns }), { customWin: '' });

    const gameStoreDebugWinPresentationModeState = useAppSelector(getDebugWinPresentationModeState);
    const gameStoreBetState = useAppSelector(getBetState);
    const [debugAvailable, setDebugAvailable] = useState(false);

    useEffect(() => {
        const flag = gameStoreDebugWinPresentationModeState?.available ?? false;
        setDebugAvailable(flag);
    }, [gameStoreDebugWinPresentationModeState]);

    const handleStartCustomWin = () => {
        if (!debugAvailable) return;

        const bet = gameStoreBetState.value.raw;
        EventsCenter.emit(EDebugWinPresentationEvents.DEBUG_WINPRESENTATION_START, { bet, winAmount: Number(state.customWin) });
    };

    return (
        <div className={styles.winMessages_custom}>
            <div className={styles.winMessages_header}>Custom Win Value:</div>

            <div className={cn(styles.winMessages_input_group, styles.debug_input_group)}>
                <input
                    type="number"
                    placeholder="Enter a win value"
                    value={state.customWin}
                    onChange={(e) => setState({ customWin: e.target.value === '' ? '' : Number(e.target.value) })}
                />
                <button onClick={handleStartCustomWin} disabled={!debugAvailable} className={cn({ [styles.disabled]: !debugAvailable })}>
                    Start
                </button>
            </div>
        </div>
    );
};

export default WinMessagesCustom;
